import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { HomePage } from '../home/home';
import { MyOrdersPage } from '../my-orders/my-orders';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { EmailTemplatePage } from '../email-template/email-template';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Home2Page } from '../home2/home2';
import { Home3Page } from '../home3/home3';
import { Home5Page } from '../home5/home5';
import { Home4Page } from '../home4/home4';
import { ConfigProvider } from '../../providers/config/config';
import { Http } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { LoadingProvider } from '../../providers/loading/loading';
import { AlertProvider } from '../../providers/alert/alert';
import { ShippingAddressPage } from '../shipping-address/shipping-address';

declare var Appsee:any;


@Component({
  selector: 'finance-offer',
  templateUrl: 'finance-offer.html',
})
export class FinancePage {
  array = new Array;
  orderid = 0;
  fin1 = 0;
  fin2 = 0;
  fin3 = 0;
  totalfinanced = 0;
    httpRunning = true;
    orders = new Array;
	offer1APR=0;
 offer1Term =0;
 offer1bullet1 = '';
 offer1bullet2 = '';
 offer1bullet3 = '';
 offer2APR=0;
 offer2Term =0;
 offer2bullet1 = '';
 offer2bullet2 = '';
 offer2bullet3 = '';
 offer3APR=0;
 offer3Term =0;
 offer3bullet1 = '';
 offer3bullet2 = '';
 offer3bullet3 = '';


  constructor(
    public navCtrl: NavController,
    public shared: SharedDataProvider,
    public config: ConfigProvider,
    public navParams: NavParams,
    public http: Http,
    translate: TranslateService,
    public alert: AlertProvider,
    public loading: LoadingProvider) {
      this.fin1 = this.navParams.get('fin1');
      this.totalfinanced = this.navParams.get('totalPrice');
      console.log("We got:",this.fin1);
      console.log("Total Financed:",this.totalfinanced);
    }

  openOrders()
	{
		//MS1115 this.navCtrl.setRoot(MyOrdersPage);
		this.navCtrl.push(ShippingAddressPage);
	}


  openHome() {
    if (this.config.homePage == 1) { this.navCtrl.setRoot(HomePage); }
    if (this.config.homePage == 2) { this.navCtrl.setRoot(Home2Page); }
    if (this.config.homePage == 3) { this.navCtrl.setRoot(Home3Page); }
    if (this.config.homePage == 4) { this.navCtrl.setRoot(Home4Page); }
    if (this.config.homePage == 5) { this.navCtrl.setRoot(Home5Page); }
  }

customEmail() {
this.navCtrl.push(EmailTemplatePage);
}
    ionViewDidLoad() {
      this.httpRunning = true;
    //  this.getFinanceOffers();
    }

  openCart() {
    this.navCtrl.push(CartPage);
  }
  openSearch() {
    this.navCtrl.push(SearchPage);
  }
  ionViewWillEnter() {
    if (this.config.admob == 1) this.shared.showAd();
  }
}



// WEBPACK FOOTER //
// ./src/pages/finance-offer/finance-offer.ts